import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('div')(
  ({ theme }: { theme: ICustomTheme }) => ({
    width: '170rem',
    maxWidth: '85%',
    margin: theme.spacing(7, 'auto'),
    [theme.breakpoints.down('md')]: {
      maxWidth: '90%',
    },
    '@media (max-width: 750px)': {
      maxWidth: '100%',
      margin: theme.spacing(2, 'auto'),
    },
  }),
);
